// Imports
import Ajaxify from './Ajaxify';
import Polyfill from './Polyfill';
import Browser from './Browser';
import Header from './Header';
import ScrollToTop from './ScrollToTop';
import Poll from './Poll';
import GTM from './GTM';
import PDF from './PDF';
import Video from './Video';
import Post from './Post';
import OneTrust from './OneTrust';

export default class TPS {

    // Constructor
    constructor() {
        // All classes instances
		this.OneTrust = new OneTrust();
        this.ajaxify = new Ajaxify();
        this.polyfill = new Polyfill();
        this.browser = new Browser();
        this.header = new Header();
        this.scrollToTop = new ScrollToTop();
        this.poll = new Poll();
        this.gtm = new GTM();
        this.pdf = new PDF();
        this.video = new Video();
        this.post = new Post();
    }

    // On DOM ready
    onDomReady() {
        const self = this;

        // On DOM ready
        document.addEventListener('DOMContentLoaded', () => {
            if (document.readyState === 'interactive' || document.readyState === 'complete') {
                self.onDomReadyCallback();
            }
        });
    }

    // On DOM ready (callback)
    onDomReadyCallback() {
        // Init before frameworks
        this.init();

        // Foundation 6 initialization
        jQuery(document).foundation();

        // Init after frameworks
        this.initAfterFrameworks();
    }

    // Init before frameworks
    init() {
        for (var i in this) {
            if (typeof this[i].init === 'function') {
                this[i].init();
            }
        }
    }

    // Init after frameworks
    initAfterFrameworks() {
        for (var i in this) {
            if (typeof this[i].initAfterFrameworks === 'function') {
                this[i].initAfterFrameworks();
            }
        }
    }

    // Destroy
    destroy() {
        for (var i in this) {
            if (typeof this[i].destroy === 'function') {
                this[i].destroy();
            }
        }
    }

}
